export const en = {
  'chart-ng-common': {
    zoom: {
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      resetView: 'Reset View'
    }
  }
};
